export { SORT_TYPES } from './sortTypes';

export const PENDING_CANCELATIONS_COLUMNS = [
  { id: 'member_name', label: 'Member', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'email', label: 'Email', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'product_name', label: 'Membership', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'status', label: 'Status', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'amount', label: 'Amount', defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'interval', label: 'Billing', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'canceled_on', label: 'Opted Out', defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'ends_at', label: 'Ends', defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'member_since', label: 'Member Since', defaultVisible: false, sortable: true, sortType: 'date' },
  { id: 'venue_name', label: 'Venue', defaultVisible: false, sortable: true, sortType: 'text' },
];

export const getDefaultVisibleColumns = () =>
  PENDING_CANCELATIONS_COLUMNS.filter((c) => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  PENDING_CANCELATIONS_COLUMNS.filter((c) => !c.defaultVisible && !c.alwaysVisible);
